/* eslint-disable  */
import { Route, Switch, Redirect } from "react-router-dom";
import AdminDashboard from "./AdminModel/AdminDashboard";
import AdminLoanApplicationDetailed from "./AdminModel/pages/AdminLoanApplicationDetailed";
import DuesDeductions from "./AdminModel/pages/DuesDeductions";
import FundDeductions from "./AdminModel/pages/FundDeductions";
import AdminFundContributionAnalysis from "./AdminModel/pages/FundContributionAnalysis";
import AdminLoanDeductionAnalysis from "./AdminModel/pages/LoanDeductionAnalysis";
import AdminAuditTrail from "./AdminModel/pages/AuditTrail";
import LoanBookings from "./AdminModel/pages/LoanBookings";
import LoanDeduction from "./AdminModel/pages/LoanDeduction";
import MemberStatement from "./AdminModel/pages/MemberStatement";
import UPNMGMembers from "./AdminModel/pages/Members";
import PaidLoans from "./AdminModel/pages/PaidLoans";
import SystemUsers from "./AdminModel/pages/SystemUsers";
import "./App.css";
import Login from "./Auth/Login";
import Logout from "./Auth/LogOut";
import HirePurchaseDashboard from "./HirePurchaseModel/HirePurchaseDashboard";
import ApprovedOrders from "./HirePurchaseModel/pages/ApprovedOrders";
import HirePurchaseMessage from "./HirePurchaseModel/pages/HirePurchaseMessage";
import HirePurchaseReport from "./HirePurchaseModel/pages/HirePurchaseReport";
import MartMemberDetailed from "./HirePurchaseModel/pages/MartMemberDetailed";
import OrderDetailed from "./HirePurchaseModel/pages/OrderDetailed";
import Orders from "./HirePurchaseModel/pages/Orders";
import OrderStatus from "./HirePurchaseModel/pages/OrderStatus";
import ProcessedOrder from "./HirePurchaseModel/pages/ProcessedOrder";
import ProductCategory from "./HirePurchaseModel/pages/ProductCategory";
import ProductDetailed from "./HirePurchaseModel/pages/ProductDetailed";
import Products from "./HirePurchaseModel/pages/Products";
import ProfileHirePurchase from "./HirePurchaseModel/pages/ProfileHirePurchase";
import RejectedOrders from "./HirePurchaseModel/pages/RejectedOrders";
import ShippedOrders from "./HirePurchaseModel/pages/ShippedOrders";
import Vendors from "./HirePurchaseModel/pages/Vendors";
import PrivateLoanAdminRoute from "./HOC/PrivateLoanAdminRoute";
import { RolesContants } from "./contants";
import PrivateMartAdminRoute from "./HOC/PrivateMartAdminRoute";
import PrivateRoute from "./HOC/PrivateRoute";
import LoansDashboard from "./LoanModel/LoansDashboard";
import UnionsDashboard from "./LoanModel/UnionsDashboard";
import BookedLoans from "./LoanModel/pages/BookedLoans";
import FundContribution from "./LoanModel/pages/FundContribution";
import InCompleteLoanApplication from "./LoanModel/pages/InCompleteLoanApplication";
import InitiatedLoans from "./LoanModel/pages/InitiatedLoans";
import LoanApplication from "./LoanModel/pages/LoanApplication";
import LoanCalculator from "./LoanModel/pages/LoanCalculator";
import LoanDetailed from "./LoanModel/pages/LoanDetailed";
import LoansMessages from "./LoanModel/pages/LoansMessages";
import LoansMessagesDetailed from "./LoanModel/pages/LoansMessagesDetailed";
import LoansNotifications from "./LoanModel/pages/LoansNotifications";
import LoanStatus from "./LoanModel/pages/LoanStatus";
import LoansPaid from "./LoanModel/pages/PaidLoans";
import ProfileLoan from "./LoanModel/pages/ProfileLoan";
import RejectedLoans from "./LoanModel/pages/RejectedLoans";
import ReportLoans from "./LoanModel/pages/ReportLoans";
import UpdatedLoanApplicationFromMembers from "./LoanModel/pages/UpdatedLoanApplicationFromMembers";
import LoanArchive from "./AdminModel/pages/LoanArchive";
import HirePurchaseMessageDetailed from "./HirePurchaseModel/pages/HirePurchaseMessageDetailed";
import AdminReport from "./AdminModel/pages/AdminReport";
import RequestedOrders from "./HirePurchaseModel/pages/RequestedOrders";
import MartNotifications from "./HirePurchaseModel/pages/MartNotifications";
import LoanArchieveDetailed from "./AdminModel/pages/LoanArchieveDetailed";
import FundIncrement from "./AdminModel/pages/FundIncrement";
import FundIncrementDetailed from "./AdminModel/pages/FundIncrementDetailed";
import AuthorizedLoans from "./LoanModel/pages/AuthorizedLoans";
import LoansDeduction from "./LoanModel/pages/LoansDeduction";
import ChartPage from "./AdminModel/pages/ChartPage";
import MartDeduction from "./HirePurchaseModel/pages/MartDeduction";
import MartFundDeduction from "./HirePurchaseModel/pages/MartFundDeduction";
import PrivateITOfficerRoute from "./HOC/PrivateITOfficerRoute";
import ITOfficerDashboard from "./ITOfficerModel/ITOfficerDashboard";
import UploadLoans from "./ITOfficerModel/pages/UploadLoans";
import UploadLoansByDate from "./ITOfficerModel/pages/UploadLoansByDate";
import UploadMart from "./ITOfficerModel/pages/UploadMart";
import UploadMartByDate from "./ITOfficerModel/pages/UploadMartByDate";
import UploadFunds from "./ITOfficerModel/pages/UploadFunds";
import UploadFundsByDate from "./ITOfficerModel/pages/UploadFundsByDate";
import FundContributionAnalysis from "./ITOfficerModel/pages/FundContributionAnalysis";
import LoanDeductionAnalysis from "./ITOfficerModel/pages/LoanDeductionAnalysis";
import ITAuditTrail from "./ITOfficerModel/pages/AuditTrail";
import UploadStaffLoans from "./ITOfficerModel/pages/UploadStaffLoans";
import UploadStaffMart from "./ITOfficerModel/pages/UploadStaffMart";
import UploadStaffFunds from "./ITOfficerModel/pages/UploadStaffFunds";
import UploadMembers from "./ITOfficerModel/pages/UploadMembers";
import ResetMemberAccount from "./ITOfficerModel/pages/ResetMemberAccount";
import SettlementRequests from "./LoanModel/pages/SettlementRequests";
import SettlementDetailed from "./LoanModel/pages/SettlementDetailed";
import SentSettlements from "./LoanModel/pages/SentSettlements";
import Clearance from "./LoanModel/pages/Clearance";
import MartSettlementRequests from "./HirePurchaseModel/pages/MartSettlementRequests";
import MartSettlementDetailed from "./HirePurchaseModel/pages/MartSettlementDetailed";
import MartSentSettlements from "./HirePurchaseModel/pages/MartSentSettlements";
import NonMembers from "./HirePurchaseModel/pages/NonMembers";
import InventoryDashboard from "./InventoryModel/InventoryDashboard";
import InventoryItems from "./InventoryModel/pages/InventoryItems";
import ScanStation from "./InventoryModel/pages/ScanStation";
import StockTake from "./InventoryModel/pages/StockTake";
import Movements from "./InventoryModel/pages/Movements";
import PrivateCustomerServiceRoute from "./HOC/PrivateCustomerServiceRoute";
import SupportDashboard from "./SupportModel/SupportDashboard";
import TicketQueue from "./SupportModel/pages/TicketQueue";
import TicketDetailed from "./SupportModel/pages/TicketDetailed";
import MemberDirectory from "./SupportModel/pages/MemberDirectory";
import MemberProfile360 from "./SupportModel/pages/MemberProfile360";
import SupportReports from "./SupportModel/pages/SupportReports";
import SupportMessages from "./SupportModel/pages/SupportMessages";
import SupportMessageDetailed from "./SupportModel/pages/SupportMessageDetailed";
import LoanStatusLookup from "./SupportModel/pages/LoanStatusLookup";
import SupportLoanApplicationDetailed from "./SupportModel/pages/LoanApplicationDetailed";
import FundsDeductionLookup from "./SupportModel/pages/FundsDeductionLookup";
import LoanDeductionLookup from "./SupportModel/pages/LoanDeductionLookup";
import SettlementLookup from "./SupportModel/pages/SettlementLookup";
import ClearanceDashboard from "./AdminModel/pages/ClearanceDashboard";
import AutoSchemeApplications from "./AdminModel/pages/AutoSchemeApplications";
import ManageVehicles from "./AdminModel/pages/ManageVehicles";
function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path={"/"} component={Login} />
        <Route exact path={"/logout"} component={Logout} />
        {/* <Route exact path={'*'} component={NotFound404}/> */}

        <PrivateRoute exact path={"/admin/home"} component={AdminDashboard} />
        {/* Unions Route */}
        <PrivateRoute exact path={"/admin/union"} component={UnionsDashboard} />

        <PrivateRoute path={"/admin/loans"} component={LoanDeduction} />
        <PrivateRoute path={"/admin/loans-bookings"} component={LoanBookings} />
        <PrivateRoute
          path={"/admin/loans-detailed"}
          component={AdminLoanApplicationDetailed}
        />
        <PrivateRoute
          path={"/admin/archieveloans-detailed"}
          component={LoanArchieveDetailed}
        />

        <PrivateRoute path={"/admin/loans-paid"} component={PaidLoans} />

        <PrivateRoute path={"/admin/funds"} component={FundDeductions} />
        <PrivateRoute path={"/admin/fund-analysis"} component={AdminFundContributionAnalysis} />
        <PrivateRoute path={"/admin/loan-analysis"} component={AdminLoanDeductionAnalysis} />
        <PrivateRoute path={"/admin/audit-trail"} component={AdminAuditTrail} />
        <PrivateRoute
          path={"/admin/fund-increment"}
          component={FundIncrement}
        />
        <PrivateRoute
          path={"/admin/fund-increment-detailed"}
          component={FundIncrementDetailed}
        />
        <PrivateRoute path={"/admin/statement"} component={MemberStatement} />
        <PrivateRoute path={"/admin/dues"} component={DuesDeductions} />
        <PrivateRoute path={"/admin/users"} component={SystemUsers} />
        <PrivateRoute path={"/admin/members"} component={UPNMGMembers} />
        <PrivateRoute path={"/admin/archives"} component={LoanArchive} />
        <PrivateRoute path={"/admin/charts"} component={ChartPage} />
        <PrivateRoute path={"/admin/report"} component={AdminReport} />
        <PrivateRoute path={"/admin/auto-scheme"} exact component={AutoSchemeApplications} />
        <PrivateRoute path={"/admin/auto-scheme/cars"} component={ManageVehicles} />
        {/* Same component as /loans/clearance — it picks the admin shell off
            the pathname. Mounted here so an admin can issue a clearance letter
            without holding the LOAN_OFFICER_HEAD role the loans route needs. */}
        <PrivateRoute path={"/admin/clearance"} exact component={Clearance} />
        <PrivateRoute
          path={"/admin/clearance-dashboard"}
          component={ClearanceDashboard}
        />

        {/* <PrivateRoute  path={'/messages'} component={Messages}/> */}
        {/* PrivateLoanAdminRoute */}

        <PrivateLoanAdminRoute
          path={"unions/home"}
          component={UnionsDashboard}
        />

        <PrivateLoanAdminRoute
          path={"/loans/home"}
          component={LoansDashboard}
        />

        <PrivateLoanAdminRoute
          path={"/loans/messages"}
          component={LoansMessages}
        />
        <PrivateLoanAdminRoute
          path={"/loans/notifications"}
          component={LoansNotifications}
        />
        <PrivateLoanAdminRoute
          path={"/loans/messages-detailed"}
          component={LoansMessagesDetailed}
        />
        <PrivateLoanAdminRoute
          path={"/loans/application"}
          component={LoanApplication}
        />
        <PrivateLoanAdminRoute
          path={"/loans/fund-deduction"}
          component={FundContribution}
        />
        <PrivateLoanAdminRoute
          path={"/loans/loans-deduction"}
          component={LoansDeduction}
        />
        <PrivateLoanAdminRoute path={"/loans/booked"} component={BookedLoans} />
        {/* <PrivateLoanAdminRoute  path={'/loans/booked-detailed'} component={BookedLoansDetailed}/> */}
        <PrivateLoanAdminRoute
          path={"/loans/initiated"}
          component={InitiatedLoans}
        />
        <PrivateLoanAdminRoute
          path={"/loans/authorized"}
          component={AuthorizedLoans}
        />
        <PrivateLoanAdminRoute path={"/loans/status"} component={LoanStatus} />
        <PrivateLoanAdminRoute path={"/loans/paid"} component={LoansPaid} />
        <PrivateLoanAdminRoute
          path={"/loans/rejected"}
          component={RejectedLoans}
        />
        <PrivateLoanAdminRoute
          path={"/loans/updated-loan"}
          component={UpdatedLoanApplicationFromMembers}
        />
        <PrivateLoanAdminRoute
          path={"/loans/incomplete-loan"}
          component={InCompleteLoanApplication}
        />
        <PrivateLoanAdminRoute
          path={"/loans/loan-detailed"}
          component={LoanDetailed}
        />
        <PrivateLoanAdminRoute
          path={"/loans/profile"}
          component={ProfileLoan}
        />
        <PrivateLoanAdminRoute
          path={"/loans/calculator"}
          component={LoanCalculator}
        />
        <PrivateLoanAdminRoute
          path={"/loans/loan-report"}
          component={ReportLoans}
        />
        <PrivateLoanAdminRoute
          path={"/loans/settlement"}
          component={SettlementRequests}
        />
        <PrivateLoanAdminRoute
          path={"/loans/settlement-detailed"}
          component={SettlementDetailed}
        />
        <PrivateLoanAdminRoute
          path={"/loans/sent-settlements"}
          component={SentSettlements}
        />
        {/* Same component — it reads "paid-settlements" off the pathname. */}
        <PrivateLoanAdminRoute
          path={"/loans/paid-settlements"}
          component={SentSettlements}
        />
        <PrivateLoanAdminRoute
          path={"/loans/clearance"}
          component={Clearance}
          roles={[RolesContants.LOAN_OFFICER_HEAD]}
        />

        <PrivateMartAdminRoute
          path={"/mart/settlement"}
          component={MartSettlementRequests}
        />
        <PrivateMartAdminRoute
          path={"/mart/settlement-detailed"}
          component={MartSettlementDetailed}
        />
        <PrivateMartAdminRoute
          path={"/mart/sent-settlements"}
          component={MartSentSettlements}
        />

        <PrivateMartAdminRoute
          path={"/mart/home"}
          component={HirePurchaseDashboard}
        />
        <PrivateMartAdminRoute
          path={"/mart/notifications"}
          component={MartNotifications}
        />
        {/* ── INVENTORY MODULE ── (Products, Category, Suppliers relocated here) */}
        <PrivateMartAdminRoute path={"/inventory/home"} component={InventoryDashboard} />
        <PrivateMartAdminRoute path={"/inventory/items"} component={InventoryItems} />
        <PrivateMartAdminRoute path={"/inventory/scan"} component={ScanStation} />
        <PrivateMartAdminRoute path={"/inventory/stock-take"} component={StockTake} />
        <PrivateMartAdminRoute path={"/inventory/movements"} component={Movements} />
        <PrivateMartAdminRoute path={"/inventory/products"} component={Products} />
        <PrivateMartAdminRoute path={"/inventory/vendors"} component={Vendors} />
        <PrivateMartAdminRoute path={"/inventory/category"} component={ProductCategory} />
        <PrivateMartAdminRoute path={"/inventory/product-detail"} component={ProductDetailed} />
        <PrivateMartAdminRoute path={"/mart/mart-deduction"} component={MartDeduction} />
        <PrivateMartAdminRoute path={"/mart/fund-deduction"} component={MartFundDeduction} />
        <PrivateMartAdminRoute path={"/mart/non-members"} component={NonMembers} />
        <PrivateMartAdminRoute
          path={"/mart/profile"}
          component={ProfileHirePurchase}
        />
        <PrivateMartAdminRoute path={"/mart/order"} component={Orders} />
        <PrivateMartAdminRoute
          path={"/mart/request-order"}
          component={RequestedOrders}
        />
        <PrivateMartAdminRoute
          path={"/mart/order-detailed"}
          component={OrderDetailed}
        />
        <PrivateMartAdminRoute
          path={"/mart/processed-order"}
          component={ProcessedOrder}
        />
        <PrivateMartAdminRoute
          path={"/mart/rejected-order"}
          component={RejectedOrders}
        />
        <PrivateMartAdminRoute
          path={"/mart/shipped-order"}
          component={ShippedOrders}
        />
        <PrivateMartAdminRoute
          path={"/mart/approved-order"}
          component={ApprovedOrders}
        />
        <PrivateMartAdminRoute
          path={"/mart/status-order"}
          component={OrderStatus}
        />
        <PrivateMartAdminRoute
          path={"/mart/report"}
          component={HirePurchaseReport}
        />
        <PrivateMartAdminRoute
          path={"/mart/messages"}
          component={HirePurchaseMessage}
        />
        <PrivateMartAdminRoute
          path={"/mart/messages-detailed"}
          component={HirePurchaseMessageDetailed}
        />
        <PrivateMartAdminRoute
          path={"/mart/member-detailed"}
          component={MartMemberDetailed}
        />

        {/* ── IT OFFICER ROUTES ── */}
        <PrivateITOfficerRoute exact path="/it/home" component={ITOfficerDashboard} />
        <PrivateITOfficerRoute path="/it/upload-loans" component={UploadLoans} />
        <PrivateITOfficerRoute path="/it/upload-loans-by-date" component={UploadLoansByDate} />
        <PrivateITOfficerRoute path="/it/upload-mart" component={UploadMart} />
        <PrivateITOfficerRoute path="/it/upload-mart-by-date" component={UploadMartByDate} />
        <PrivateITOfficerRoute path="/it/upload-funds" component={UploadFunds} />
        <PrivateITOfficerRoute path="/it/upload-funds-by-date" component={UploadFundsByDate} />
        <PrivateITOfficerRoute path="/it/fund-analysis" component={FundContributionAnalysis} />
        <PrivateITOfficerRoute path="/it/loan-analysis" component={LoanDeductionAnalysis} />
        <PrivateITOfficerRoute path="/it/audit-trail" component={ITAuditTrail} />
        <PrivateITOfficerRoute path="/it/upload-staff-loans" component={UploadStaffLoans} />
        <PrivateITOfficerRoute path="/it/upload-staff-mart" component={UploadStaffMart} />
        <PrivateITOfficerRoute path="/it/upload-staff-funds" component={UploadStaffFunds} />
        <PrivateITOfficerRoute path="/it/upload-members" component={UploadMembers} />
        <PrivateITOfficerRoute path="/it/reset-member" component={ResetMemberAccount} />

        {/* ── CUSTOMER SERVICE (CRM + TICKETING) ── */}
        <PrivateCustomerServiceRoute exact path={"/support/home"} component={SupportDashboard} />
        <PrivateCustomerServiceRoute path={"/support/tickets"} component={TicketQueue} />
        <PrivateCustomerServiceRoute path={"/support/ticket-detailed"} component={TicketDetailed} />
        <PrivateCustomerServiceRoute path={"/support/members"} component={MemberDirectory} />
        <PrivateCustomerServiceRoute path={"/support/member-detailed"} component={MemberProfile360} />
        <PrivateCustomerServiceRoute path={"/support/messages-detailed"} component={SupportMessageDetailed} />
        <PrivateCustomerServiceRoute path={"/support/messages"} component={SupportMessages} />
        <PrivateCustomerServiceRoute path={"/support/loan-status"} component={LoanStatusLookup} />
        {/* Read-only loan application form opened from Loan Status. */}
        <PrivateCustomerServiceRoute path={"/support/loan-detailed"} component={SupportLoanApplicationDetailed} />
        <PrivateCustomerServiceRoute path={"/support/loan-deduction"} component={LoanDeductionLookup} />
        <PrivateCustomerServiceRoute path={"/support/funds-deduction"} component={FundsDeductionLookup} />
        <PrivateCustomerServiceRoute path={"/support/settlements"} component={SettlementLookup} />
        {/* Same component as /loans/calculator — it picks the support shell
            off the pathname. */}
        <PrivateCustomerServiceRoute
          path={"/support/calculator"}
          component={LoanCalculator}
        />
        {/* Same component as /loans/settlement-detailed — it picks the support
            shell off the pathname. Lets the desk process a request without
            handing the agent the loans module. */}
        <PrivateCustomerServiceRoute
          path={"/support/settlement-detailed"}
          component={SettlementDetailed}
        />
        {/* SentSettlements serves both: it reads "paid-settlements" off the
            pathname to decide which status to load. */}
        <PrivateCustomerServiceRoute
          path={"/support/sent-settlements"}
          component={SentSettlements}
        />
        <PrivateCustomerServiceRoute
          path={"/support/paid-settlements"}
          component={SentSettlements}
        />
        <PrivateCustomerServiceRoute
          path={"/support/reports"}
          component={SupportReports}
          roles={[RolesContants.CUSTOMER_SERVICE_HEAD]}
        />

        <Redirect to="/" />
      </Switch>
    </div>
  );
}

export default App;
